import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { DynamicDataObk, Graph_QL } from "../../..";
import { isEqual, keyBy, merge } from "lodash";
import { AutoReport } from "../GQLCalls/autoReportCall";

export type AutoReportItem = DynamicDataObk<AutoReport[]>

const autoReportDataAdapter = createEntityAdapter({
  selectId: (item: AutoReportItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<AutoReportItem, string>, { con, data }: AutoReportItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "auto_report_id");
    data.forEach((entry) => dataDictionary[entry.auto_report_id] = entry);
    const newPayload = { con, data: Object.values(dataDictionary) };
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      autoReportDataAdapter.upsertOne(state, newPayload);
    }
  } else { autoReportDataAdapter.addOne(state, { con, data }) }
}

const updatePayloadAndState = (state: EntityState<AutoReportItem, string>, {con, data}: AutoReportItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "auto_report_id")
    data.forEach((entry) => dataDictionary[entry.auto_report_id] = merge({}, entry, dataDictionary[entry.auto_report_id]));
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      autoReportDataAdapter.upsertOne(state, newPayload);
    }
  } else { autoReportDataAdapter.addOne(state, {con, data})}
}

const removeDeletedFromState = (state: EntityState<AutoReportItem, string>, {con, data}: AutoReportItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const idsToRemove = data.map((autoReport) => (autoReport.auto_report_id));
    const newPayload = {con, data: state.entities[identifier].data.filter((autoReport) => !idsToRemove.includes(autoReport.auto_report_id))}
    autoReportDataAdapter.upsertOne(state, newPayload);
  }
}

const autoReportSlice = createSlice({
  name: "autoReport",
  initialState: autoReportDataAdapter.getInitialState(),
  reducers: {
    update: (state, { payload }: PayloadAction<AutoReportItem>) => {
      updatePayloadAndState(state, payload);
    },
    maintained: (state, { payload }: PayloadAction<AutoReportItem>) => {
      mergePayloadAndState(state, payload);
    },
    deleted: (state, { payload }) => {
      removeDeletedFromState(state, payload)
    }
  }
})

export const autoReportActions = autoReportSlice.actions;
export default autoReportSlice.reducer;